// The string the iOS webkit handler expects (Sparta parity).
const CLOSE_WEB_ONBOARDING_MESSAGE = 'closeWebOnboarding';

/**
 * Hand back to the native app to dismiss the onboarding webview at completion —
 * Sparta's `initiateCloseOnboardingInNative` (sparta/src/user/utils). The native
 * shell injects a bridge: Android exposes a `handleCloseWebOnboarding()` method,
 * iOS a `handleCloseWebOnboarding` WKWebView message handler.
 *
 * No-op when neither bridge is present (plain web / iframe / SSR). Returns `true`
 * when a bridge was invoked, `false` otherwise.
 */
export function closeWebOnboardingInNative(): boolean {
  if (typeof window === 'undefined') return false;

  if (window.android?.handleCloseWebOnboarding) {
    window.android.handleCloseWebOnboarding();
    return true;
  }

  if (window.webkit?.messageHandlers?.handleCloseWebOnboarding?.postMessage) {
    window.webkit.messageHandlers.handleCloseWebOnboarding.postMessage(
      CLOSE_WEB_ONBOARDING_MESSAGE
    );
    return true;
  }

  return false;
}
